import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { OriginProjectsClient, IOriginProjectsClient } from "app/ApiClient";
import { IState } from "../index";
import { defaultOriginProjectsState, NormalizedOriginProject } from "./originProjectState";

const originProjectsClient: IOriginProjectsClient = new OriginProjectsClient(process.env.REACT_APP_API_URL);

export const originProjectSlice = createSlice({
  name: "dimensionsProjectsState",
  initialState: defaultOriginProjectsState,
  reducers: {
    resetOriginProjects: () => defaultOriginProjectsState,
    originProjectsStarted: (state) => {
      state.processing = true;
      state.finished = false;
      state.succeed = false;
      state.failed = false;
    },
    originProjectsSucceed: (state, { payload }: { payload: NormalizedOriginProject[] }) => {
      state.processing = false;
      state.finished = true;
      state.succeed = true;
      state.failed = false;
      state.originProjects = payload;
    },
    originProjectsFailed: (state) => {
      state.processing = false;
      state.finished = true;
      state.succeed = false;
      state.failed = true;
    },
  },
});

export const getOriginProjects = createAsyncThunk(
  "originProject/getOriginProjects",
  async (sourceId: number, { dispatch }) => {
    dispatch(originProjectsStarted());
    try {
      const response = await originProjectsClient.getAll(sourceId);
      dispatch(originProjectsSucceed(response.filter((item) => item.name) as NormalizedOriginProject[]));
    } catch (apiException) {
      dispatch(originProjectsFailed());
      console.error("Api Exception", apiException);
    }
  },
);

export const { originProjectsFailed, originProjectsStarted, originProjectsSucceed, resetOriginProjects } =
  originProjectSlice.actions;

export const originProjectsSelector = (state: IState) => state.originProjects;

export default originProjectSlice.reducer;
